module.exports = "/_next/static/resources/box-31f43f7eb5b33d67dd8fe1912d382a8f.jpg";